export enum PackageStatusType {
  Undefined = "Undefined",
  OnTheWay = "OnTheWay",
  Arrived = "Arrived",
  Storage = "Storage",
  Sorted = "Sorted",
  Assigned = "Assigned",
  HeadingPickup = "HeadingPickup",
  PickedUp = "PickedUp",
  InTransit = "InTransit",
  Delivered = "Delivered",
  Returned = "Returned",
  Canceled = "Canceled"
}
